module.exports = __webpack_public_path__ + "static/media/use22.f2d84e56.png";